import { fromJS } from "immutable";
import { getEntity } from "data/entity";

export const getSpreedlyValid = (state) => state.spreedly.get("isValid");

export const getSpreedlyToken = (state) => state.spreedly.get("token");

export const getSpreedlyRunValidation = (state) => state.spreedly.get("runValidation");

export const getSpreedlyYearError = (state) => getSpreedlyErrors(state).get("year");
export const getSpreedlyMonthError = (state) => getSpreedlyErrors(state).get("month");

export const getSpreedlyErrors = (state) => {
  return state.spreedly.get("validationErrors").count() > 0
    ? state.spreedly.get("validationErrors")
    : fromJS({});
};
